import produce from 'immer';

// TYPES
import { ReducerAction } from 'store/modules/types';
import { Types, emitirSegundaViaPlaca } from './types';

export const INITIAL_STATE: emitirSegundaViaPlaca = {
	status: 0,
	data: null,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerAction,
): emitirSegundaViaPlaca {
	return produce(state, draft => {
		switch (action.type) {
			case Types.EMITIR_SEGUNDA_VIA_PLACA_REQUEST: {
				break;
			}

			case Types.EMITIR_SEGUNDA_VIA_PLACA_SUCCESS: {
				draft.status = 200;
				draft.data = action.payload;
				break;
			}

			case Types.EMITIR_SEGUNDA_VIA_PLACA_FAILURE: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			case Types.EMITIR_SEGUNDA_VIA_PLACA_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			default:
		}
		return draft;
	});
}
